import React, { useEffect, useCallback } from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import PropTypes from 'prop-types';
import metadata from './PUPVehicleInfoComponent.metadata.json5';
import messages from './PUPVehicleInfoComponent.messages';

function PUPVehicleInfoComponent(props) {
    const translator = useTranslator();
    const {
        value: vehicleVM,
        id,
        quoteID,
        isVinDuplicated,
        onValueChange,
        path,
        index,
        updateVehicleDetails,
        showValidationErrors,
        onValidate,
        isVehiclePrivateOrClassic,
        isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal,
        isVinNoLookupVehicleType
    } = props;
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    const isRecreationalVehicle = useCallback(() => {
        switch (vehicleVM.type.value.code) {
            case 'atv_snowmobile_ml':
                return true;
            default:
                return false;
        }
    }, [vehicleVM.type.value.code]);

    const isVehicleTypeOther = useCallback(() => {
        switch (vehicleVM.type.value.code) {
            case 'Other':
                return true;
            default:
                return false;
        }
    }, [vehicleVM.type.value.code]);

    const isVinFilled = useCallback(() => {
        return !!vehicleVM.vin.value && vehicleVM.vin.value.length === 17;
    }, [vehicleVM.vin.value]);

    const writeValue = (value, changedPath) => {
        onValueChange(value, `${path}.${changedPath}`);
    };

    const overrideProps = {
        vehicleDivider: {
            visible: index !== 0
        },
        vehiclex: {
            content: translator(messages.vehicleX, { vehicleIndex: (index + 1) })
        },
        yearMake: {
            content: vehicleVM.value.getYearMakeNameML()
        },
        modelTrim: {
            content: `${vehicleVM.value.getModelNameML()} ${vehicleVM.value.getTrimNameML()}`
        },
        vehiclePrivateOrClassicRowContainer: {
            visible: isVehiclePrivateOrClassic(vehicleVM)
        },
        vinNoLookupVehicleTypeRowContainer: {
            visible: isVinNoLookupVehicleType(vehicleVM)
        },
        vehicleVinLookupComponent: {
            isPUP: true,
            vehicleVM,
            quoteID,
            isVinDuplicated,
            onValueChange,
            path,
            index,
            onValidate,
            updateVehicleDetails,
            startupVerification: isVinFilled()
        },
        vinInput: {
            label: isRecreationalVehicle() ? translator(messages.vinOrSerialNumber) : translator(messages.vinNumber),
            placeholder: isRecreationalVehicle() ? translator(messages.vinOrSerialNumberPlaceholder) : translator(messages.vinNumberPlaceholder)
        },
        trailerGolfCartOrLowSpeedOrOtherPersonalRowContainer: {
            visible: isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal(vehicleVM)
        },
        vehicleTypeOtherRowContainer: {
            visible: isVehicleTypeOther(vehicleVM)
        },
        vehicleTypeOtherVinContainer: {
            visible: !!vehicleVM.vin
        },
        vehicleTypeOtherSerialNumContainer: {
            visible: !!vehicleVM.serialNumber
        },
        vinInputBottomLabel: {
            visible: vehicleVM.vin.aspects.valid
        },
        otherVehVinInputBottomLabel: {
            visible: vehicleVM.vin.aspects.valid
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={vehicleVM}
            onValidationChange={setComponentValidation}
            onValueChange={writeValue}
            showErrors={showValidationErrors}
        />
    );
}

PUPVehicleInfoComponent.propTypes = {
    value: PropTypes.shape({}).isRequired,
    id: PropTypes.string.isRequired,
    isVinDuplicated: PropTypes.func.isRequired,
    onValueChange: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired,
    quoteID: PropTypes.string,
    index: PropTypes.number.isRequired,
    updateVehicleDetails: PropTypes.func.isRequired,
    showValidationErrors: PropTypes.bool.isRequired,
    onValidate: PropTypes.func.isRequired,
    isVehiclePrivateOrClassic: PropTypes.func.isRequired,
    isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal: PropTypes.func.isRequired,
    isVinNoLookupVehicleType: PropTypes.func.isRequired
};

PUPVehicleInfoComponent.defaultProps = {
    quoteID: undefined
};

export default PUPVehicleInfoComponent;
